/* eslint-disable sort-keys-fix/sort-keys-fix */
import { defineMessages } from '@formatjs/intl';

export const localeKiosk = {
  productPage: defineMessages({
    chefRecommendedPairingsTitle: {
      defaultMessage: 'Chef recommended pairings',
      id: 'vinhood.vinhood_kiosk.productPage.chefRecommendedPairingsTitle',
    },
    perfectPairing: {
      defaultMessage: 'The perfect pairing?',
      id: 'vinhood.vinhood_kiosk.productPage.perfectPairingText',
    },
    pairingCta: {
      defaultMessage: 'Discover more pairings',
      id: 'vinhood.vinhood_kiosk.productPage.pairingCtaText',
    },
    similarOptions: {
      defaultMessage: 'Interested? Explore similar options',
      id: 'vinhood.vinhood_kiosk.productPage.similarOptionsText',
    },
  }),
  characterDetails: defineMessages({
    characterTitle: {
      defaultMessage: 'The ideal products for you have this Character:',
      id: 'vinhood.vinhood_kiosk.characterDetails.ResultIntroText',
    },
  }),
  fidelityDetachButton: defineMessages({
    fidelityCardLabel: {
      defaultMessage: 'Detach my loyalty card',
      id: 'vinhood.vinhood_kiosk.header.detachMyLoyaltyCard',
    },
  }),
  resultPage: defineMessages({
    btn: {
      defaultMessage:
        '{productCategory, select, wine {See all #{ characterName } { productCategoryPluralText }} beer {See all #{ characterName } { productCategoryPluralText }} coffee {See all #{ characterName } { productCategoryPluralText }} other {}}',
      id: 'vinhood.vinhood_kiosk.resultPage.ResultCtaCatalog',
    },
    scanTitle: {
      defaultMessage: 'Scan your loyalty card to save this result',
      id: 'vinhood.vinhood_kiosk.resultPage.ResultTitleScan',
    },
    scanDescription: {
      defaultMessage: 'Use the kiosk’s barcode scanner below to link this result to your card.',
      id: 'vinhood.vinhood_kiosk.resultPage.ResultTextScan',
    },
  }),
  fidelityCard: defineMessages({
    fidelityCardTitle: {
      defaultMessage: `Ooops`,
      id: 'vinhood.vinhood_kiosk.loyaltyCard.fidelityCardTitle',
    },
    notFoundFidelityCard: {
      defaultMessage: 'Sorry, your scanned fidelity card was not found. Please try again.',
      id: 'vinhood.vinhood_kiosk.loyaltyCard.notFoundFidelityCard',
    },
    notCardOrEan: {
      defaultMessage: `Sorry, but I couldn't recognize the barcode you scanned as a card or an EAN.`,
      id: 'vinhood.vinhood_kiosk.loyaltyCard.notCardOrEan',
    },
    serviceUnavailable: {
      defaultMessage: 'Sorry, the scanning service is currently unavailable.',
      id: 'vinhood.vinhood_kiosk.loyaltyCard.serviceUnavailable',
    },
    foundFidelityCardTitle: {
      defaultMessage: 'You did it!',
      id: 'vinhood.vinhood_kiosk.loyaltyCard.foundFidelityCardTitle',
    },
    foundFidelityCardSubtitle: {
      defaultMessage: 'We recognized your card. Let the experience begin!',
      id: 'vinhood.vinhood_kiosk.loyaltyCard.foundFidelityCardSubtitle',
    },
    alreadyAssociatedFidelityCard: {
      defaultMessage:
        'Taste Match: your new favorite function to discover the affinity between a product and your palate. Do the Taste Test again to unlock it completely!',
      id: 'vinhood.vinhood_kiosk.loyaltyCard.alreadyAssociatedFidelityCard',
    },
    disconnectedFidelityCardTitle: {
      defaultMessage: 'Done!',
      id: 'vinhood.vinhood_kiosk.loyaltyCard.disconnectedFidelityCardTitle',
    },
    disconnectedFidelityCardSubtitle: {
      defaultMessage: 'You have disconnected from the kiosk.',
      id: 'vinhood.vinhood_kiosk.loyaltyCard.disconnectedFidelityCardSubtitle',
    },
  }),
  welcomePageText: defineMessages({
    pageTitle: {
      defaultMessage: 'Find your ideal {productCategoryText}',
      id: 'vinhood.vinhood_kiosk.welcomePage.pageTitle',
    },
    pageInfo: {
      defaultMessage: 'powered by **Vinhood**',
      id: 'vinhood.vinhood_kiosk.welcomePage.pageInfo',
    },
    ctaBtn: {
      defaultMessage: 'Start',
      id: 'vinhood.vinhood_kiosk.welcomePage.ctaBtn',
    },
  }),
  popupBanner: defineMessages({
    titleCard: {
      defaultMessage: 'Do you have a fidelity card?',
      id: 'vinhood_kiosk.popupBanner.titleCard',
    },
    descriptionCard: {
      defaultMessage: 'Scan your card below to save your taste preference.',
      id: 'vinhood_kiosk.popupBanner.descriptionCard',
    },
    titleQr: {
      defaultMessage: 'Don’t miss your result! scan and take it with you',
      id: 'vinhood_kiosk.popupBanner.titleQr',
    },
    descriptionQr: {
      defaultMessage: 'Continue your product search on the go by scanning the QR code',
      id: 'vinhood_kiosk.popupBanner.descriptionQr',
    },
  }),
  resultCatalogPage: defineMessages({
    seeMoreProducts: {
      defaultMessage: '{ productCategory, select, other { See more { productCategoryPluralText }}}',
      id: 'vinhood.vinhood_kiosk.resultCatalogPage.seeMoreProducts',
    },
  }),
  homePage: defineMessages({
    takeTestTitle: {
      defaultMessage: '{ productCategory, select, other { Find the **ideal { productCategoryText }** for your taste}}',
      id: 'vinhood.vinhood_kiosk.homePage.takeTestTitle',
    },
    beginQuizBtn: {
      defaultMessage: 'Begin quiz',
      id: 'vinhood.vinhood_kiosk.homePage.beginQuizBtn',
    },
    yourCharacterIs: {
      defaultMessage: 'Your character is',
      id: 'vinhood.vinhood_kiosk.homePage.yourCharacterIs',
    },
    seeYourSuggestedProductsBtn: {
      defaultMessage: '{ productCategory, select, other { See your suggested { productCategoryPluralText }}}',
      id: 'vinhood.vinhood_kiosk.homePage.seeYourSuggestedProductsBtn',
    },
    tasteChanged: {
      defaultMessage: 'Has your taste changed? **Try the test again**',
      id: 'vinhood.vinhood_kiosk.homePage.tasteChanged',
    },
    catalogBtn: {
      defaultMessage: 'Explore the full catalog',
      id: 'vinhood.vinhood_kiosk.homePage.catalogBtn',
    },
    scanBarcodeAndFidelityBannerText: {
      defaultMessage: 'Scan a product or your fidelity card to know more!',
      id: 'vinhood.vinhood_kiosk.homePage.scanBarcodeAndFidelityBannerText',
    },
    scanBarcodeBannerText: {
      defaultMessage: 'Scan a product to know more',
      id: 'vinhood.vinhood_kiosk.homePage.scanBarcodeBannerText',
    },
    scanCTABannerBtn: {
      defaultMessage: 'Scan it!',
      id: 'vinhood.vinhood_kiosk.homePage.scanCTABannerBtn',
    },
    scanBannerTitle: {
      defaultMessage: 'Switch to mobile!',
      id: 'vinhood.vinhood_kiosk.homePage.scanBannerTitle',
    },
    scanBannerSubtitle: {
      defaultMessage: 'Scan the QR code ',
      id: 'vinhood.vinhood_kiosk.homePage.scanBannerSubtitle',
    },
    barcodeBannerTitle: {
      defaultMessage: '{ productCategory, select, other { Know more about a { productCategoryText }!}}',
      id: 'vinhood.vinhood_kiosk.homePage.barcodeBannerTitle',
    },
    barcodeBannerSubtitle: {
      defaultMessage: 'Scan the barcode below',
      id: 'vinhood.vinhood_kiosk.homePage.barcodeBannerSubtitle',
    },
  }),
  findMeModal: defineMessages({
    findMeText: {
      defaultMessage: 'Find me',
      id: 'vinhood.vinhood_kiosk.findMeModal.findMeText',
    },
    GetOnThePhoneText: {
      defaultMessage: 'Not much time? ||Get on the phone!',
      id: 'vinhood.vinhood_kiosk.findMeModal.GetOnThePhoneText',
    },
    ScanQrCodeText: {
      defaultMessage: 'scan the QR code',
      id: 'vinhood.vinhood_kiosk.findMeModal.ScanQrCodeText',
    },
  }),
};
